import React from "/vendor/react";
import { SvgIcon } from "/vendor/@material-ui/core";
import Bg from "./Bg";

interface Props {
  color: string;
}

const Icon = React.memo(({ color, ...props }: Props) => {
  return (
    <SvgIcon viewBox="0 0 64 64" {...props}>
      <Bg color={color}>
        <path
          d="M31.1 61.4l2.7 4.4-1.5.4a37.4 37.4 0 01-11.3-.9c-.7-.2-1.4-2.2-2-6.1L31 61.4z"
          fill="#BAA67F"
        />
        <path
          d="M23 49.3c3-8 4-14 3.5-17.8-.4-2-2.2-6.5-3.5-7.8-3.1-3.3 0-7 0-3.3.1 2.5 15.8 3.2 17.6 11 .6 2.7-5.3 8.7-17.6 18z"
          fill="#96825B"
        />
        <path
          d="M14.5 14.2c2-3.1 3.8-5.2 5.4-6.3 5.9-4 10.2-2.6 13-2.7 3.6-.2 6 4.4 7.7 5.5 1.2.8 4.3 3.4 7.4 7.6 2.2 3-.7 3.7 0 7 .4 2.2 5.7-.9 4 3.8-.8 2.7-3.6 8.2-8.2 16.5 0-20-2-31.2-5.9-33.5-2.4-1.4-1.5-.5-6.8 0-1.3.1-10.5-.4-12 0-1.5.3-3 1-4.6 2.1z"
          fill="#7D6C4C"
        />
        <path
          d="M20.7 13.4c3.6-3.7 6.3-5.8 8.2-6.3 11.4-3 21 5.9 22.3 9.2.6 1.4 3.1 7.5 3.2 12.9.1 3.8-.3 6.7-1.7 9.9-.9 2-2.5 4.4-6.4 7.4-2.3 1.7-7.7 4.6-16 8.8 11.3-16.6 16-27 14.2-31.2-1.9-4.2-9.8-7.7-23.8-10.7z"
          fill="#96825B"
        />
        <path
          d="M27.5 22.4l3 .8h.3l.1.1h.1l.4.3c2 1.2 2.8 2.2 3.2 3.4v.2c.2.4.2.8.4 1.7L35 30v.6l.5 1.8v.5a18.4 18.4 0 01-1.6 5.7c-.8 1-1.6 1.6-3 2.6l-.7.4-.7.4a18.3 18.3 0 00-8.2 8.4l-.4.8-.3.7c-1.5 3.4-2 5.5-1.2 7.8l1.6 4.7 9.5-3.2-1.3-3.8 1.1-2.7c.8-1.7 1.7-2.5 4.2-4l1.3-.9c2.5-1.6 4.2-3 5.9-5a22.7 22.7 0 003.5-14.6l-.1-.5v-.2l-.2-1-.2-1.3c-.1-1.2-.3-1.8-.5-2.7-1.1-3.8-3.5-6.9-7.7-9.4l-.6-.4-.3-.2a12.3 12.3 0 00-1-.4l-.8-.3-.5-.2-4-1c-2.1-.5-4.9 0-10.2 1.7L13.6 16l3 9.5 4.8-1.5 5.1-1.5h.5l.5-.2z"
          fill="#BAA67F"
          fillRule="nonzero"
        />
        <path
          d="M32.7 31c1.4-.6 2-3 1-5.6-.8-2.6-1.9-2-3.3-1.5s-2.6.6-1.8 3.2 2.7 4.3 4.1 3.8z"
          fill="#6C6C6C"
        />
        <path
          d="M34 37.1l-.1.2-.1.2a15.4 15.4 0 01-2.6 3.4l-1.5 1-1.1.5c-2.2 1-3.2 1.7-4.1 2.9l-.5.6-1.7 2.2a23 23 0 00-2.1 3l-.3.6-.4.8c-2.2 4-2.7 6.4-1 9.8l1 2.3 4.5-2.2-1-2.2c-.8-1.6-.6-2.5.7-5l.6-1.1.3-.5c.1-.4.6-1.1 1.5-2.2l1.7-2.2.4-.5.2-.3c.3-.4.8-.7 2.1-1.4l.7-.3c1.5-.7 2.4-1.2 3.3-2 1.7-1.5 4-4.8 4.3-6.4V38l.1-.1.3-.6a9.1 9.1 0 00.8-2.9l.1-.8c.2-1.5 0-3-.6-4.7l-.1-.5-.6-1.7c-.8-3.3-2-5.5-4.7-6.8l-.4-.1-.3-.2c-.7-.4-2-1-3.7-2.1L27 16l-2.6 4.2 3.1 2 1.3.6 2.7 1.6.4.1c1 .4 1.5 1.4 2 3.2v.3l.7 2a8.6 8.6 0 01.5 3.7 7.2 7.2 0 01-.4 1.4l-.3.7L34 37v0z"
          fill="#DECAA4"
          fillRule="nonzero"
        />
        <path
          d="M14.5 26.6c4.3 2.3 11.9-.3 14-4.3 2.1-4 4.6-8 .3-10.3-4.2-2.3-16-.6-18.1 3.3-2.1 4-.4 9 3.8 11.3z"
          fill="#BAA67F"
        />
        <path
          d="M34.4 34.5c.8-.4 1-1.8.3-3.2-.6-1.4-.8.1-1.6.5s-2-.5-1.4.9c.7 1.3 1.8 2.1 2.7 1.8zM47.1 25.7c1.4-.4 2-3 1-5.5-.8-2.6-1.9-2-3.3-1.4-1.4.4-2.6.5-1.8 3.1s2.7 4.3 4.1 3.8zM46.8 30.3c1-.1 1.6-1.4 1.4-2.9-.1-1.5-.7-.1-1.6 0-1 0-1.8-1.2-1.6.3.1 1.5 1 2.6 1.8 2.6z"
          fill="#6C6C6C"
        />
        <path fill="#DECAA4" d="M27.5 60.2l2 13.5-6.4 1.2z" />
        <g transform="translate(8.4 17.6)">
          <path
            d="M8.8 9.4L7.4 7.7l-.8.7C4.6 9.9 3.5 11.1 3 12c-.6 1.3 0 2.8 1.7 4.5l.8.8L7 15.8l-.7-.8c-.6-.6-1-1.1-1.2-1.6L5 13c.2-.5 1.2-1.5 2.7-2.7l1-.9z"
            fill="#F297A9"
            fillRule="nonzero"
          />
          <path
            fill="#F297A9"
            fillRule="nonzero"
            d="M5.3 12.5l-1.8-1.2-3 4.5L2.3 17z"
          />
          <ellipse fill="#000" cx="12.9" cy="1.6" rx="2.2" ry="1.6" />
          <ellipse fill="#000" cx="4.2" cy="1.6" rx="2.2" ry="1.6" />
        </g>
      </Bg>
    </SvgIcon>
  );
});
Icon.displayName = "Avatar.Snake";

export default Icon;
